import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
export const EXE_COUNTER_VALUE_ACCESSOR:any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectMultipleComponent),
  multi: true
};
@Component({
  selector: 'app-select-multiple',
  templateUrl: './select-multiple.component.html',
  styles: [],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class SelectMultipleComponent implements OnInit, ControlValueAccessor {
  @Input() options;//下拉选项
  @Input() optionLabel;//下拉选项label
  @Input() optionValue;//下拉选项value
  @Input() disabled;//是否禁用
  @Input() view;//是否为查看

  propagateChange = (_:any) => {
  };

  writeValue(obj:any):void {
    if(obj){
      this.innerValue = obj.split(",");
    }
  }

  registerOnChange(fn:any):void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn:any):void {
  }

  changeVal(val) {
    this.propagateChange(val.join(","));

  }
  constructor() { }
  public innerValue:any = [];
  ngOnInit() {
  }

}
